import Box from '@mui/material/Box'
import appBoxy from '../../svg/boxyIcons/appsBoxy.svg'
import appDefault from '../../svg/defaultIcons/appsDefault.svg'

const AppIcon = () => {
    const iconSelect = localStorage.getItem('iconsSelect')
    const icon = iconSelect === 'Boxy' ? appBoxy : appDefault

    return (
        <Box sx={{ display: 'flex', height: 35, width: 35 }}>
            <Box component='img' src={icon} alt='App' sx={{ height: 35, width: 35 }} />
        </Box>
    )
}

export default AppIcon
